import { observer } from '@legendapp/state/react';
import Base from './components/specific/base/Base';

const App = observer(() => {
  return <Base />
})

export default App;